module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "z-index": "100"
    }
  }, [_c('nav', {
    staticClass: "animated bounceInLeft",
    attrs: {
      "id": "sidebar"
    }
  }, [_c('div', {
    staticClass: "sidebar-header"
  }, [_c('h3', {
    staticStyle: {
      "padding": "0",
      "margin": "0",
      "text-align": "center"
    }
  }, [_c('router-link', {
    staticStyle: {
      "font-size": "40px",
      "line-height": "40px"
    },
    attrs: {
      "to": "about"
    }
  }, [_vm._v("FluPrint")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "10px",
      "clear": "both",
      "line-height": "10px",
      "float": "left",
      "text-align": "center",
      "width": "100%"
    }
  }, [_vm._v("(official project website)")])], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled components"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "about"
    }
  }, [_vm._v("About project")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "exploratory?page=edge"
    }
  }, [_vm._v("SIMON manuscript")])], 1), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#pageSubmenu",
      "data-toggle": "collapse",
      "aria-expanded": "false"
    }
  }, [_vm._v("FluPrint Database")]), _vm._v(" "), _c('ul', {
    staticClass: "collapse list-unstyled",
    attrs: {
      "id": "pageSubmenu"
    }
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "database"
    }
  }, [_vm._v("Overview")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "database-access"
    }
  }, [_vm._v("On-line access")])], 1)])]), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "about-me"
    }
  }, [_vm._v("about me")])], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled components"
  }, [_c('p', [_vm._v("resources:")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "title": "send me an email",
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.contactForm = true
      }
    }
  }, [_vm._v("contact me")])]), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)]), _vm._v(" "), (_vm.contactForm === true) ? _c('div', {
    staticClass: "main-contact panel panel-default animated bounceIn"
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("Please contact me using form below:")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.contactForm = false
      }
    }
  }, [_vm._v("close")]), _vm._v(" "), _c('div', {
    ref: "contactform",
    attrs: {
      "tabindex": "-1",
      "id": "contactform"
    }
  }, [_vm._m(7)])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "article",
    attrs: {
      "title": "Powerful, flexible, open-source and easy to use knowledge discovery application",
      "href": "https://genular.org",
      "target": "_blank"
    }
  }, [_vm._v("@SIMON - knowledge discovery platform")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "article",
    attrs: {
      "title": "open source fluprint database",
      "href": "https://github.com/LogIN-/fluprint",
      "target": "_blank"
    }
  }, [_vm._v("@fluprint - source")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "article",
    attrs: {
      "title": "calculate intersections with ease",
      "href": "https://github.com/LogIN-/mulset",
      "target": "_blank"
    }
  }, [_vm._v("@mulset - sparsity intersections")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "title": "follow me on twitter",
      "href": "https://twitter.com/TomicAdriana",
      "target": "_blank"
    }
  }, [_vm._v("@TomicAdriana")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "article",
    attrs: {
      "title": "knowledge discovery platfom",
      "href": "https://genular.org",
      "target": "_blank"
    }
  }, [_c('div', {
    staticClass: "bottom-nav",
    attrs: {
      "title": "SIMON Says..."
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "clear": "both",
      "position": "relative",
      "margin-top": "25px",
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('a', {
    staticClass: "iubenda-white iubenda-embed",
    attrs: {
      "href": "https://www.iubenda.com/privacy-policy/86726075",
      "title": "Privacy Policy "
    }
  }, [_vm._v("Privacy Policy")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "clear": "both",
      "position": "relative",
      "margin-top": "0",
      "width": "100%",
      "text-align": "center"
    }
  }, [_c('a', {
    staticStyle: {
      "color": "#FFFFFF"
    },
    attrs: {
      "href": "https://github.com/LogIN-/fluprint.com",
      "target": "_blank"
    }
  }, [_vm._v("website source code")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('iframe', {
    attrs: {
      "src": "//mautic.genular.org/form/3",
      "width": "400",
      "height": "500"
    }
  }, [_c('p', [_vm._v("Your browser does not support iframes.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-26a9c7a5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/views/Layout/components/Sidebar/index.vue
// module id = 1220
// module chunks = 1